import * as moment from "moment";

export type PlanningPeriodBoundary = "start" | "end";

export function formatPlanningPeriodBoundary(
  value: any,
  boundary: PlanningPeriodBoundary,
  inputFormat?: string
): string {
  const selectedDate = inputFormat
    ? moment(value, inputFormat, true)
    : moment.isMoment(value)
      ? value.clone()
      : moment(value);

  if (boundary === "start") {
    selectedDate.startOf("day");
  } else {
    selectedDate.endOf("day").milliseconds(0);
  }

  return selectedDate.format("YYYY-MM-DDTHH:mm:ssZ");
}

export function encodePlanningPeriodBoundary(
  value: any,
  boundary: PlanningPeriodBoundary,
  inputFormat?: string
): string {
  return encodeURIComponent(formatPlanningPeriodBoundary(value, boundary, inputFormat));
}
